import { mapValues, mapKeys, capitalize } from 'lodash'

import { admins } from './admins'
import { accounts } from './accounts'
import { bankAccounts } from './bankAccounts'
import { batchedPayouts } from './batchedPayouts'
import { batchedBookings } from './batchedBookings'
import { bookings } from './bookings'
import { campaigns } from './campaigns'
import { categories } from './categories'
import { conversations } from './conversations'
import { destinations } from './destinations'
import { events } from './events'
import { files } from './files'
import { followups } from './followups'
import { hostApplications } from './hostApplications'
import { invites } from './invites'
import { offlinereviews } from './offlinereviews'
import { organizations } from './organizations'
import { overrides } from './overrides'
import { partners } from './partners'
import { partnerDemands } from './partnerDemands'
import { payouts } from './payouts'
import { places } from './places'
import { playlists } from './playlists'
import { pricings } from './pricings'
import { references } from './references'
import { replies } from './replies'
import { requests } from './requests'
import { reviews } from './reviews'
import { schedules, emptySchedule } from './schedules'
import { searches } from './searches'
import { tags } from './tags'
import { users } from './users'
import { availabilitiesByDate } from './availabilitiesByDate'
import { criteria, countries, currencies, languages } from './statics'

conversations.schema.define({ followups: [followups.schema] })
followups.schema.define({ conversation: conversations.schema })

events.schema.define({ followups: [followups.schema] })
followups.schema.define({ event: events.schema })

bookings.schema.define({ followups: [followups.schema] })
followups.schema.define({ booking: bookings.schema })

requests.schema.define({ followups: [followups.schema] })
followups.schema.define({ request: requests.schema })

partners.schema.define({ followups: [followups.schema] })
followups.schema.define({ partner: partners.schema })

const schemasAndRecordsByEntity = {
  accounts,
  admins,
  availabilitiesByDate,
  bankAccounts,
  batchedPayouts,
  batchedBookings,
  bookings,
  campaigns,
  categories,
  conversations,
  countries,
  criteria,
  currencies,
  destinations,
  emptySchedule,
  events,
  files,
  followups,
  hostApplications,
  invites,
  languages,
  offlinereviews,
  organizations,
  overrides,
  partners,
  partnerDemands,
  payouts,
  places,
  playlists,
  pricings,
  references,
  replies,
  requests,
  reviews,
  schedules,
  searches,
  tags,
  users,
}

export function getSchemaByEntity(key) {
  return schemasAndRecordsByEntity[key].schema
}
export function getRecordByEntity(key) {
  return schemasAndRecordsByEntity[key].Record
}

export const schemas = mapValues(schemasAndRecordsByEntity, (value) => value.schema)
export const records = mapValues(
  mapKeys(schemasAndRecordsByEntity, (v, key) => capitalize(key)), // turn { accounts: [object] } into { Accounts: [object] }
  (value) => value.Record, // map Record
)

export const recordsByEntities = mapValues(schemasAndRecordsByEntity, (value) => value.Record)

export default schemasAndRecordsByEntity
